import React, { useEffect } from 'react';

import { post } from '../api';
import { getAppUrl } from '../config';

const goToIntegrations = () => window.location.replace(`${getAppUrl()}/settings?tab=integrations`);

export default function ShopifyActivateCharge() {
  const query = new URLSearchParams(window.location.search);
  const chargeId = query.get('charge_id');

  useEffect(() => {
    post('/integrations/shopify/activate_charge/', { charge_id: chargeId }).then(goToIntegrations);
  });

  return <div>Activating recurring charge, hold on...</div>;
}
